export default __webpack_public_path__ + "static/media/edit.2c22d6dd.svg";